import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as articleTypeService from '../../services/article-type';

// Async thunk to fetch article types
export const fetchArticleTypes = createAsyncThunk(
    'articleTypes/fetchAll',
    async (_, { rejectWithValue }) => {
        try {
            const result = await articleTypeService.fetchArticleTypes();

            return result;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
    {
        condition: (_, { getState }) => {
            const state = getState();

            // Prevent duplicate requests if already loading
            if (state.articleTypes.status === 'loading') {
                return false;
            }

            return true;
        },
    }
);

const initialState = {
    articleTypes: [],
    articleTypeDict: {}, // Dictionary with idArticleType as key
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
};

const articleTypeSlice = createSlice({
    name: 'articleTypes',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchArticleTypes.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchArticleTypes.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.articleTypes = action.payload;
                // Create dictionary for easy lookup
                state.articleTypeDict = action.payload.reduce((dict, type) => {
                    dict[type.idArticleType] = type;
                    return dict;
                }, {});
            })
            .addCase(fetchArticleTypes.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    },
});

export const { clearError } = articleTypeSlice.actions;

// Selectors
export const selectAllArticleTypes = (state) => state.articleTypes.articleTypes;
export const selectArticleTypeDict = (state) => state.articleTypes.articleTypeDict;
export const selectArticleTypeById = (state, id) => state.articleTypes.articleTypeDict[id];
export const selectArticleTypeStatus = (state) => state.articleTypes.status;
export const selectArticleTypeError = (state) => state.articleTypes.error;

export default articleTypeSlice.reducer;
